import { render, staticRenderFns } from "./PeriodicMonthlyReport.vue?vue&type=template&id=3131935a&"
import script from "./PeriodicMonthlyReport.vue?vue&type=script&lang=js&"
export * from "./PeriodicMonthlyReport.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicMonthlyReport.vue?vue&type=style&index=0&id=3131935a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports